/*!
 * Alpha Posts - Version: 2.4.0
 * Indeed - Copyright (c) 2026
 * This file is generated automatically. Do not edit.
 *
 * Contains sources adapted from Twitter Bootstrap v4.0.0-alpha.3, which are
 * licensed under MIT (https:
 */

const listOptions = {
  valueNames: ['name'],
  pagination: [{
    innerWindow: 1,
    outerWindow: 1,
    item: '<li><button class="page"></button></li>',
  }],
};

const MIN_SPINNER_DISPLAY_MS = 200;

let userList, paginationWrapper, nextButton, prevButton, alphaPostsSearch, listLoadingOverlay, listLoadingText;
let spinnerShownAt = 0;
let spinnerHideTimeoutId = null;
function nextPreviousInit() {
  prevButton.disabled = true;
  paginationWrapper.dataset.page = "1";
  paginationWrapper.dataset.pages = Math.ceil(userList.items.length / listOptions.page).toString();
  userList.on('filterComplete', () => updatePagination());
  userList.on('searchComplete', () => updatePagination());
  updatePageOnNumberClick();
  showNextPage();
  showPreviousPage();
}
function updatePagination() {
  if (!paginationWrapper || !prevButton || !nextButton) {
    return;
  }
  prevButton.disabled = true;
  paginationWrapper.dataset.page = "1";
  paginationWrapper.dataset.pages = Math.ceil(userList.matchingItems.length / listOptions.page).toString();
  if (paginationWrapper.dataset.pages === '1') {
    const singlePaginationButton = document.querySelector('.alphaposts-pagination-wrapper li');
    if (singlePaginationButton) {
      singlePaginationButton.classList.add('single-page');
    }
    nextButton.disabled = true;
  } else {
    nextButton.disabled = false;
  }
}
function updatePageOnNumberClick() {
    document.addEventListener('click', function(e) {
      const pageEl = e.target.closest('a.page') || e.target.closest('button.page');
      if (!pageEl) {
        return;
      }
      const pageNumber = pageEl.innerText.trim();
      if (pageNumber === '...') {
        return;
      }
      runWithListSpinner(() => {
        prevButton.disabled = false;
        nextButton.disabled = false;
        paginationWrapper.dataset.page = pageNumber;
        if (pageNumber === '1') {
          prevButton.disabled = true;
        }
        if (paginationWrapper.dataset.pages === pageNumber) {
          nextButton.disabled = true;
        }
      });
    });
}
function showNextPage() {
    nextButton.addEventListener('click', function() {
      if (parseInt(paginationWrapper.dataset.page, 10) >= parseInt(paginationWrapper.dataset.pages, 10)) {
        return;
      }
      runWithListSpinner(() => {
        prevButton.disabled = false;
        if (parseInt(paginationWrapper.dataset.pages, 10) - parseInt(paginationWrapper.dataset.page, 10) === 1) {
          nextButton.disabled = true;
        }
        const start = parseInt(paginationWrapper.dataset.page, 10) * listOptions.page + 1;
        userList.show(start, listOptions.page);
        paginationWrapper.dataset.page = (parseInt(paginationWrapper.dataset.page, 10) + 1).toString();
      });
    });
}
function showPreviousPage() {
  prevButton.addEventListener('click', function() {
    if (parseInt(paginationWrapper.dataset.page, 10) <= 1) {
      return;
    }
    runWithListSpinner(() => {
      nextButton.disabled = false;
      if (parseInt(paginationWrapper.dataset.page, 10) === 2) {
        prevButton.disabled = true;
      }
      const start = ((parseInt(paginationWrapper.dataset.page, 10) - 1) * listOptions.page + 1) - listOptions.page;
      userList.show(start, listOptions.page);
      paginationWrapper.dataset.page = (parseInt(paginationWrapper.dataset.page, 10) - 1).toString();
    });
  });
}

function showListSpinner() {
  if (!listLoadingOverlay) {
    return;
  }
  if (spinnerHideTimeoutId !== null) {
    clearTimeout(spinnerHideTimeoutId);
    spinnerHideTimeoutId = null;
  }
  spinnerShownAt = Date.now();
  listLoadingOverlay.classList.add('is-visible');
  if (listLoadingText) {
    listLoadingText.textContent = 'Loading';
  }
}

function hideListSpinner() {
  if (!listLoadingOverlay) {
    return;
  }
  const elapsed = Date.now() - spinnerShownAt;
  const delay = Math.max(0, MIN_SPINNER_DISPLAY_MS - elapsed);
  spinnerHideTimeoutId = setTimeout(() => {
    listLoadingOverlay.classList.remove('is-visible');
    if (listLoadingText) {
      listLoadingText.textContent = '';
    }
    spinnerHideTimeoutId = null;
  }, delay);
}

function runWithListSpinner(fn) {
  showListSpinner();
  setTimeout(() => {
    try {
      fn();
    } finally {
      hideListSpinner();
    }
  }, 0);
}

function setupAlphaFilterButtons() {
  const buttons = document.querySelectorAll('.alphaposts-filter-button');
  if (!buttons.length) {
    return;
  }
  const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
  const existingFirstLetters = new Set(
    userList.items.map((item) => item.values().name.charAt(0).toUpperCase())
  );
  const missingLetters = alphabet.filter((letter) => !existingFirstLetters.has(letter));

  buttons.forEach((button) => {
    const alphaFilter = button.dataset.filter && button.dataset.filter.split(',');

    if (alphaFilter && alphaFilter.length === 1 && missingLetters.includes(alphaFilter[0])) {
      button.disabled = true;
    }

    button.addEventListener('click', function(e) {
      const activeButton = document.querySelector('.alphaposts-filter-button.active');
      if (activeButton) {
        activeButton.classList.remove('active');
      }
      e.currentTarget.classList.add('active');

      runWithListSpinner(() => {
        if (alphaPostsSearch && userList.searched) {
          alphaPostsSearch.value = '';
          userList.fuzzySearch();
        }

        if (alphaFilter) {
          userList.filter((item) => alphaFilter.includes(item.values().name.charAt(0).toUpperCase()));
        } else {
          userList.filter();
        }
      });
    });
  });
}

function alphapostsReady() {
    initializeAlphapostsPageSize();
    userList = new List('alphaposts-list-wrapper', listOptions);
    alphaPostsSearch = document.querySelector('.alphaposts-search');
    listLoadingOverlay = document.querySelector('.alphaposts-list-loading');
    listLoadingText = listLoadingOverlay ? listLoadingOverlay.querySelector('.alphaposts-list-loading-text') : null;

    const alphaPostsNoResults = document.querySelector('.alphaposts-no-results');
    const alphaPostsListWrapper = document.querySelector('.alphaposts-list');

    setupAlphaFilterButtons();

    function doSearch(e) {
        if (userList.filtered) {
            userList.filter();
        }
        userList.fuzzySearch(e.target.value.trim(), ['name']);
    }

    if (alphaPostsSearch) {
        alphaPostsSearch.addEventListener('input', (e) => {
            runWithListSpinner(() => doSearch(e));
        });
    }

    function showHideNoResults(e) {
        const showNoResults = e.visibleItems.length === 0;
        if (alphaPostsNoResults) {
            alphaPostsNoResults.style.display = showNoResults ? 'block' : 'none';
        }
        if (alphaPostsListWrapper) {
            alphaPostsListWrapper.style.display = showNoResults ? 'none' : 'block';
        }
    }

    if (alphaPostsNoResults) {
        userList.on('searchComplete', showHideNoResults);
        userList.on('filterComplete', showHideNoResults);
    }
    setTimeout(()=>{
        paginationWrapper = document.querySelector('.alphaposts-pagination-wrapper');
        nextButton = document.querySelector('.alphaposts-pagination-arrow.next');
        prevButton = document.querySelector('.alphaposts-pagination-arrow.previous');
        nextPreviousInit();
    }, 0);
}

function initializeAlphapostsPageSize() {
    if (window.innerWidth < 579) {
        listOptions.page = 12;
    } else if (window.innerWidth < 768) {
        listOptions.page = 20;
    } else if (window.innerWidth < 992) {
        listOptions.page = 18;
    } else {
        listOptions.page = 40;
    }
}

function updateAlphapostsPageSize() {
    if (!userList) {
        return;
    }
    if (window.innerWidth < 579) {
        if (userList.page !== 12) {
            userList.page = 12;
            userList.update();
        }
    } else if (window.innerWidth < 768) {
        if (userList.page !== 20) {
            userList.page = 20;
            userList.update();
        }
    } else if (window.innerWidth < 992) {
        if (userList.page !== 18) {
            userList.page = 18;
            userList.update();
        }
    } else {
        if (userList.page !== 40) {
            userList.page = 40;
            userList.update();
        }
    }
}

document.addEventListener("DOMContentLoaded", alphapostsReady);
window.addEventListener("resize", updateAlphapostsPageSize);
